import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 停用產品。
 * `POST /crm/product/{id}/deactivate`；body `{ updatedAt }`。
 *
 * @param {string} id
 * @param {{ updatedAt?: string }} [payload]
 */
export async function deactivateProduct(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/product/${id}/deactivate`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
